export const environment = {
  production: false,
  apiUrl: '/server',
  contentUrl: 'https://dvkkk6z0cvz0q.cloudfront.net',
  wsUrl:'wss://development.globalrockstar.com/ws',
  lock: false,
  staticRole: ['co-label', 'superAdmin']
};
